import { StatsSlice as StatsSliceCL } from '@comicrelief/component-library';
import { snakeCase } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { paddingOptionMapping } from '../../utils/optionMapping';
import renderRichText from '../RichText/RichText';

const StatsSlice = ({ data }) => {
  const {
    statNodes,
    ...cmsData
  } = data;
  // process CMS setting values into component-friendly values
  // page background and text colour
  const pageBackgroundColour = snakeCase(cmsData.pageBackgroundColour) || undefined;

  // padding
  const paddingTop = cmsData.paddingAbove
    ? paddingOptionMapping[cmsData.paddingAbove] : undefined;
  const paddingBottom = cmsData.paddingBelow
    ? paddingOptionMapping[cmsData.paddingBelow] : undefined;

  // process stat nodes into component-friendly values
  const processedStatNodes = statNodes.map((node) => {
    const nodeBody = node.body ? renderRichText(node.body, 'white') : null;
    return {
      ...node,
      body: nodeBody
    };
  });

  // animation
  // there's also an optional characterStagger prop that we're not currently using
  let ease;
  let characterDuration;
  switch (cmsData.animation) {
    case 'Smooth':
    default:
      ease = 'cubic';
      characterDuration = '1600ms';
      break;
    case 'Bounce':
      ease = 'overshoot';
      characterDuration = '1200ms';
      break;
    case 'None':
      ease = 'none';
      characterDuration = '0';
      break;
  }

  return (
    <StatsSliceCL
      nodes={processedStatNodes}
      ease={ease}
      characterDuration={characterDuration}
      pageBackgroundColour={pageBackgroundColour}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
    />
  );
};

const StatsSliceNodePropTypes = {
  title: PropTypes.string.isRequired,
  stat: PropTypes.string,
  body: PropTypes.shape({
    body: PropTypes.string
  })
};

StatsSlice.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    pageBackgroundColour: PropTypes.string,
    statNodes: PropTypes.arrayOf(PropTypes.shape(StatsSliceNodePropTypes)),
    paddingAbove: PropTypes.string,
    paddingBelow: PropTypes.string
  }).isRequired
};

export default StatsSlice;
